import { useState } from 'react'
import { monthlyWrapped, load, BADGES, dailyStreak } from '../lib/storage'
import { isPlus } from '../lib/user'
import { share } from '../lib/share'
import { TopBar } from './TopBar'
import { BottomNav } from './BottomNav'

export function Wrapped() {
  const w = monthlyWrapped(); const s = load()
  const [toast, setToast] = useState('')
  const monthName = new Date(w.month + '-01T00:00:00Z').toLocaleString('en-GB', { month: 'long', year: 'numeric', timeZone: 'UTC' })
  const doShare = async () => {
    const r = await share(`Way Off · ${monthName}\n${w.total.toLocaleString('en-US')}/${w.max.toLocaleString('en-US')} over ${w.days} days\n${w.emoji}\nwithin 1.5× on ${w.sharp} questions · avg ${w.avgOrdersOff.toFixed(1)} orders of magnitude off\nhttps://wayoffgame.com`)
    setToast(r === 'copied' ? 'Copied' : r === 'shared' ? 'Shared!' : 'Could not share'); setTimeout(() => setToast(''), 1800)
  }
  return (
    <div className="screen">
      <TopBar />
      <h1 style={{ fontSize: 28, margin: '18px 0 4px' }}>{monthName}</h1>
      <p className="muted" style={{ margin: 0 }}>Your month, so far.</p>
      {w.days === 0 ? <p className="muted" style={{ marginTop: 20 }}>Play a day and your Wrapped starts here.</p> : (
        <>
          <div className="row"><div className="card"><h3>Total</h3><div className="score" style={{ fontSize: 34 }}>{w.total.toLocaleString('en-US')}<small>/{w.max.toLocaleString('en-US')}</small></div></div><div className="card"><h3>Days played</h3><div className="score">{w.days}</div></div></div>
          <div className="row"><div className="card"><h3>Within 1.5×</h3><div className="stat"><b>{w.sharp}</b> questions</div></div><div className="card"><h3>Avg miss</h3><div className="stat"><b>{w.avgOrdersOff.toFixed(1)}</b> orders</div><div className="tiny">of magnitude — lower is better</div></div></div>
          <div className="card"><h3>Your month in emoji</h3><div className="emoji-string" style={{ fontSize: 22 }}>{w.emoji}</div></div>
          {w.best && <div className="card"><h3>Best day</h3><div className="stat">{w.best.theme.emoji} {w.best.theme.name} · {w.best.score.toLocaleString('en-US')}</div><div className="emoji-string" style={{ fontSize: 20 }}>{w.best.emoji}</div></div>}
          <div className="card"><h3>Streak</h3><div className="stat">🔥 {dailyStreak(undefined, isPlus())} days</div></div>
          <div className="actions"><button className="btn block" onClick={doShare}>Share my month ↗</button></div>
        </>
      )}
      <div className="card"><h3>Badges</h3>
        <div className="badges">{Object.entries(BADGES).map(([id, b]) => <div key={id} className={'badge' + (s.badges[id] ? ' on' : '')}><span className="em">{b.emoji}</span><b>{b.name}</b><div>{b.desc}</div></div>)}</div>
      </div>
      {toast && <div className="toast">{toast}</div>}
      <BottomNav />
    </div>
  )
}
